import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FunctionsService } from '../../services/functions.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxStripeModule } from '@nomadreservations/ngx-stripe';
import { BreadcrumbModule } from 'xng-breadcrumb';
import { MatTableModule } from '@angular/material/table'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSortModule } from '@angular/material/sort'
import { AlertHistoryComponent } from '../alert-history/alert-history.component';
import { AlertHistoryRoutingModule } from './alert-history-routing.module';
import { NgxPermissionsModule } from 'ngx-permissions';
import { environment } from 'src/environments/environment';
import { AlertHistoryLogComponent } from './alert-history-log/alert-history-log.component';
import { AgmCoreModule } from '@agm/core';
import { ExportAlertHistoryComponent } from './export-alert-history/export-alert-history.component';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ViewAlertHistoryComponent } from './view-alert-history/view-alert-history.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ExportAlertLogComponent } from './export-alert-log/export-alert-log.component';
import { AlertChatHistoryLogComponent } from './alert-chat-history-log/alert-chat-history-log.component';
import { ExportAlertChatLogComponent } from './export-alert-chat-log/export-alert-chat-log.component';
import { AuthInterceptorProvider } from 'src/app/services/token/token-interceptor.service';

@NgModule({
    declarations: [
        AlertHistoryComponent,
        AlertHistoryLogComponent,
        ExportAlertHistoryComponent,
        ViewAlertHistoryComponent,
        ExportAlertLogComponent,
        AlertChatHistoryLogComponent,
        ExportAlertChatLogComponent
    ],
    imports: [
        AlertHistoryRoutingModule,
        BreadcrumbModule,
        CommonModule,
        FormsModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        MatNativeDateModule,
        MatTableModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
        MatSortModule,
        NgbModule,
        NgxPermissionsModule,
        NgxSpinnerModule,
        NgxStripeModule.forRoot(environment.stripe_pk),
        ReactiveFormsModule,
        TranslateModule,
        AgmCoreModule.forRoot({
            apiKey: environment.firebaseConfig.apiKey
        }),
        SharedModule
    ],
    exports: [
        SharedModule
    ],
    providers: [FunctionsService, AuthInterceptorProvider]
})
export class AlertHistoryModule { }